import { createFileRoute } from '@tanstack/react-router'
import ProaPage from '../../../app/financial/proa/page'

export const Route = createFileRoute('/_auth/financial/proa')({
  component: ProaPage
})
